import { useSortBy } from "react-instantsearch";
import { productSortOptions } from "@/frontend/algolia/search-shared/client";
import { Checkbox } from "./ui/Checkbox";
import { cn } from "../../utils/cn";


export function SortByFilter({ className }: { className?: string }) {
    const { options, currentRefinement, refine } = useSortBy({ items: productSortOptions })

    return (
      <ul>
        {options.map((opt, index) => {
          const id = `${opt.value}-${index}`;

          return (
            <li key={opt.value} className={cn("tw-h-10 tw-flex tw-items-center tw-space-x-2", className)}>
              <Checkbox
                id={id}
                value={opt.value}
                checked={currentRefinement === opt.value}
                onCheckedChange={() => refine(opt.value)}
                className="tw-h-4 tw-w-4 tw-border-dark-green-100 tw-text-white checked:tw-bg-red-400"
              />

              <label className="tw-text-sm tw-font-light tw-text-gray-700 tw-cursor-pointer tw-select-none" htmlFor={id}>
                {opt.label}
              </label>
            </li>
          )
        })}
      </ul>
    )
}